import React,{ Suspense, memo } from "react";
import { Switch, Route, } from "react-router";

import routes from "./routes"
import Loader from "../PhylloConnectComponents/CommonComponents/FullScreenLoader";


function Routes() {
    return (
      <>
      <Suspense fallback={<Loader />}>
        <Switch>
        {routes.map((itm) =>
                <Route
                  key={itm.name}
                  exact={itm.exact}
                  path={itm.path}
                  name={itm.name}
                  component={itm.component}
                />
            )}
        </Switch>
        </Suspense>
      </>
    );
  }
  export default Routes;